import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import TextareaAutosize from 'vue-textarea-autosize';
import browserDetect from "vue-browser-detect-plugin";
import vSelect from 'vue-select';
import lineClamp from 'vue-line-clamp';
import {format, parse} from 'date-fns';
import Toasted from 'vue-toasted';
import VueMask from 'v-mask';
import { directive as onClickOutside } from 'vue-on-click-outside';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import axios from "axios";
import Info from "@/components/general/Info";
import VTooltip from 'v-tooltip'
import vueTopProgress from "@/../submodules/vue-base/components/TopProgress";
import VAutosizeInput from 'v-autosize-input';

import PerfectScrollbar from 'vue2-perfect-scrollbar';


Vue.directive('on-click-outside', onClickOutside);
Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
	  el.clickOutsideEvent = function (event) {
		// here I check that click was outside the el and his children
		if (!(el == event.target || el.contains(event.target))) {
		  // and if it did, call method provided in attribute value
		  vnode.context[binding.expression](event);
		}
	  };
	  document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
	  document.body.removeEventListener('click', el.clickOutsideEvent)
	},
  });

Vue.config.productionTip = false;

Vue.filter('date', function(value) {
	value += " +0000";
	var d = parse(value, 'yyyy-MM-dd HH:mm:ss XX', new Date());
	if (value) {
		return format(d, 'M/dd/yyyy HH:mm');
	}
});

Vue.filter('membersTime', function(value) {
	try {
	value += " +0000";
	var d = parse(value, 'yyyy-MM-dd HH:mm:ss XX', new Date());
	if (value) {
		return format(d, 'HH:mm');
	}
	}catch(error) {
		return ""
	}
});

Vue.filter('membersDate', function(value) {
	try {
	value += " +0000";
	var d = parse(value, 'yyyy-MM-dd HH:mm:ss XX', new Date());
	if (value) {
		return format(d, 'MM/dd');
	}
	}catch(error) {
		return ""
	}
});

Vue.filter('dateformat', function(value) {
	value += " +0000";
	var d = parse(value, 'yyyy-MM-dd HH:mm:ss XX', new Date());
	if (value) {
		return format(d, 'M/dd/yyyy');
	}
});

Vue.filter('datetime', function(value) {
	if(!value){
		return ""
	}
	value += " +0000";
	var d = parse(value, 'yyyy-MM-dd HH:mm:ss.SSS XX', new Date());

	return format(d, 'M/dd/yyyy h:mm a');
	
});

Vue.filter('listdate', function(value) {
	value += " +0000";
	var d = parse(value, 'yyyy-MM-dd HH:mm XX', new Date());
	if (value) {
		return format(d, 'MM/dd');
	}
});

//Vue.use(vueTopProgress)
Vue.use(VueMask);
Vue.use(TextareaAutosize);
Vue.use(browserDetect);
Vue.use(VAutosizeInput);
Vue.use(Toasted);
Vue.use(lineClamp);
Vue.use(PerfectScrollbar);
Vue.use(VTooltip, {
		defaultDelay: {show: 350, hide: 0},
		defaultOffset: 0
})

Vue.component('v-select', vSelect);
Vue.component('date-picker', DatePicker);
Vue.component('Info',Info);
Vue.component('vue-topprogress',vueTopProgress);

axios.interceptors.response.use((response) => {
	// Check for license redirect signal (hardware mismatch or expired trial)
	if(response.data.redirect_to){
		window.location = response.data.redirect_to;
		return response;
	}

    if(!response.data.success && (typeof response.data === 'string' && response.data.includes("<!DOCTYPE html>"))){
    	window.location="/signin";
	}else if(!response.data.success && response.data.error_message=="SIGNOUT"){
		window.location="/";
	}
  	return response;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");